import { useState, useEffect, useCallback } from "react";
import 'react-phone-number-input/style.css';
import IconButton from '@mui/material/IconButton';
import useInputKeys from 'hooks/useInputKeys';
import InputBase from '@mui/material/InputBase';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LoadingButton from 'components/Shared/LoadingButton';
import Button from '@mui/material/Button';
import BackspaceIcon from '@mui/icons-material/Backspace';
import { useSubmitOTP, useRequestOTP } from 'hooks/auth';
import { getItem, setItem, setRefreshTokenCookie, setAccessTokenCookie } from "lib/Storage";
import { useTranslation } from 'react-i18next';
import './index.scss';
import { useTheme } from "@emotion/react";


function VerifyForm({ phoneNumber, setPhoneNumber, setStep }) {
  const { t } = useTranslation();
  const [alert, setAlert] = useState('');
  const [resendTime, setResendTime] = useState(180);
  const [wink, setWink] = useState(true);
  const theme= useTheme();

  const { strInput, setStrInput, setIsLoggedIn, direction, handleClearStr } = useInputKeys();
  const { mutate: verifyCode, isLoading: verifyLoading } = useSubmitOTP();
  const { mutate: sendCodeAgain, isLoading: codeLoading } = useRequestOTP();

  const minutes = Math.floor(resendTime / 60);
  let seconds = resendTime % 60;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  const timeString = `${minutes}:${seconds}`;

  const archivePhoneNumber = useCallback(() => {
    setStrInput('');
    setPhoneNumber(phoneNumber);
  }, [setStrInput, setPhoneNumber, phoneNumber]);

  const handleBack = () => {
    archivePhoneNumber();
    setStep(1);
  };
  useEffect(() => {
    archivePhoneNumber();
    const intervalId = setInterval(() => {
      setResendTime((prevTime) => prevTime > 0 ? prevTime - 1 : 0);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [archivePhoneNumber]);
  const handleVerify = () => {
    verifyCode(strInput, {
      onSuccess: (data) => {
        if (data?.status === "OK") {
          setRefreshTokenCookie(data.refreshToken);
          setAccessTokenCookie(data?.accessToken)
          setIsLoggedIn(true);
          let existingLanguage = getItem('lng');
          if(!existingLanguage){
            setItem('lng', "en");
            setItem('dir', "ltr");
          }
          
        }
      },
      onError: (err) => {
        console.log("error in inside onError", err)
        setAlert('verificationCodeIsNotValid');
      }
    });
  };
  const handleResend = () => {
    sendCodeAgain(phoneNumber, {
      onSuccess: (data) => {
        if (data?.status === "OK") {
          setAlert('');
          setResendTime(180);
        } else if (data?.status === "ALREADY REQUESTED!") {
          console.log('از اس ام اس قبلیمون به شما کمتر از ۳ دقیقه گذشته! لطفا بعدا امتحان کنین.', {
            variant: 'error',
          })
        }
      },
    });
  };

  useEffect(() => {
    setTimeout(() => {
      setWink(!wink)
    }, 500);
  }, [wink])

  return (
    <div className={`code-wrapper ${direction === 'ltr' ? "ltr-style" : "rtl-style"}`} style={{ border: `1px solid ${theme.palette.primary.main}` }}>
      <LoadingButton
        className="verify-button"
        onClick={handleVerify}
        loading={verifyLoading}
        disabled={!strInput?.length}
        style={{ borderLeft: `1px solid ${theme.palette.primary.main}` }}
      >
        {t('verify')}
      </LoadingButton>
      <IconButton
        onClick={handleClearStr}
        aria-label="delete"
        size="small"
        disabled={!strInput?.length || verifyLoading}
        sx={{
          color: `${theme.palette.primary.main}!important`,
          fontSize: '1.5rem',
          position: 'absolute',
          right: '31%',
          top: '17%',
          zIndex: 5,
        }}
        className={`backspacebutton ${strInput.length > 0 ? "" : "hide"}`}
      >
        <BackspaceIcon style={{color: theme.palette.primary.main}}/>
      </IconButton>
      <InputBase
        fullWidth
        readOnly
        className="main-input"
        sx={{
          fontFamily: 'bahnschrift',
        }}
        value={`${strInput}${wink ? "_" : ''}`}
      />
      <div className="remained-time">
        {timeString}
      </div>
      <div className="info-box">
        <span className="code-sent">
          {t('verificationCodeHasBeenSend')} "{phoneNumber}"
        </span>
        <span className="edit-number" onClick={handleBack} style={{ color: theme.palette.primary.main }}>
          {t('editPhoneNumber')}
        </span>
      </div>
      {resendTime === 0 ? (
        <div className="send-code-again">
          <span className="not-received">
            {t('didNotReceiveACode')}
          </span>
          <Button variant="text" className="send-again" onClick={handleResend} disabled={codeLoading} style={{ color: theme.palette.primary.main, borderBottom: `1px solid ${theme.palette.primary.main}` }}>
            {t('sendANewCode')}
          </Button>
        </div>
      ) : alert.length ? (
        <div className="input-alert" style={{ color: theme.palette.error.main }}>
          <InfoOutlinedIcon
            sx={{ color: theme.palette.error.main, fontSize: '0.8rem' }}
          />
          <span >
            {t(alert)}
          </span>
        </div>
      ) : null
      }
    </div>
  );
};

export default VerifyForm;
